import { WishlistItemEntity } from "@apps/wishlist/entities/WishlistItemEntity";

import { WishlistItemSdkDto } from "../types";

export function mapWishlistItemToSdkDto(
    item: WishlistItemEntity
): WishlistItemSdkDto {
    return {
        wishlistId: item.wishlistId,
        customerId: item.customerId,
        productId: item.productId,
        variantId: item.variantId,
        date: item.date,
        quantity: item.quantity,
    };
}
